export enum FormVariant {
  SELF = 'Self',
  CHILD = 'Child'
}

export enum FormState {
  IDLE,
  LOADING,
  SUCCESS,
  ERROR
}

export enum FormButtonKind {
  FILLED,
  OUTLINED
}
